import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { StoreState, UserState } from '../../redux-types';
import { AddOnTypes } from "../constants/TenantFields";

type WrapperProps = {
  addOnType: AddOnTypes;
}

const AddOnProtectedWrapper: React.FC<PropsWithChildren<WrapperProps>> = (props) => {
  const user = useSelector<StoreState, UserState>((state) => state.user);
  if (props.addOnType === undefined) {
    return props.children;
  }
  
  const userTenantHasAddOn = user.addonControls[props.addOnType];

  if (!userTenantHasAddOn) {
    return null;
  }

  return props.children;
};

export default AddOnProtectedWrapper;
